import React from "react";

import Text from "../shared/Text";

const SuccessMessage: React.FC = () => {
  return (
    <>
      <Text as="h2">Your saying was submitted!</Text>
      <Text as="p">
        Thanks for contributing. We'll review your submission and add it as soon
        as possible.
      </Text>
    </>
  );
};

export default SuccessMessage;
